// // export default LoginScreen;
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../css/LoginScreen.css";
// import logo from "../assets/qavach-logo.png";
// import Button from "../components/common/Button";
// import { authApi } from "../services/authApi";
// import { tokenStore } from "../services/tokenStore";
// import { fetchCurrentUser } from "../services/currentUserApi";
// import { useAuth } from "../context/AuthContext";



// function pickLandingRoute(roleKeys: string[]) {
//   const keys = roleKeys.map((x) => String(x).trim().toLowerCase());

//   console.log("ROLE KEYS:", roleKeys);

//   if (keys.includes("teledoctor")) return "/queue/teledoctor";

//   if (keys.includes("tele_dentist") || keys.includes("teledental"))
//     return "/queue/teledental";

//   if (keys.includes("pediatric_resident") || keys.includes("pediatric"))
//     return "/queue/pediatric";

//   if (keys.includes("dermatologist") || keys.includes("dermatology"))
//     return "/queue/dermatology";

//   if (keys.includes("tele_final_doctor") || keys.includes("telefinaldoctor"))
//     return "/queue/tele-final-doctor";

//   // ❌ NO fallback — strict role-based routing
//   throw new Error("No valid role found for routing");
// }

// const LoginScreen: React.FC = () => {
//   const navigate = useNavigate();
//   const { setAuth } = useAuth();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [busy, setBusy] = useState(false);
//   const [err, setErr] = useState<string | null>(null);

//   const handleLogin = async () => {
//     setBusy(true);
//     setErr(null);

//     try {
//       // 1) Login -> access token
//       const resp = await authApi.login(email, password);
//       const accessToken = resp.access_token;

//       if (!accessToken)
//         throw new Error("No access_token returned from backend");

//       // 2) store token (so refresh works too)
//       tokenStore.set({ accessToken });

//       // 3) currentUser -> roleAssignments
//       const me = await fetchCurrentUser(accessToken);

//       // Normalize roleAssignments (trim + lowercase key, trim name)
//       const normalizedRoleAssignments = (me?.roleAssignments || []).map(
//         (ra: any) => ({
//           ...ra,
//           role: {
//             ...(ra.role || {}),
//             key: String(ra?.role?.key || "")
//               .trim()
//               .toLowerCase(),
//             name: String(ra?.role?.name || "").trim(),
//           },
//         }),
//       );

//       // Active role keys (this is what we will use everywhere)
//       const roleKeys: string[] = normalizedRoleAssignments
//         // .filter((ra: any) => ra?.status === "ACTIVE")
//         .filter((ra: any) => String(ra?.status).toLowerCase() === "active")
//         .map((ra: any) => ra?.role?.key)
//         .filter(Boolean);

//       // 4) store doctor + roles in AuthContext + tokenStore
//       setAuth({ accessToken }, {
//         name: me?.user?.raw?.name || "Doctor",
//         email: me?.user?.raw?.email,
//         picture: me?.user?.raw?.picture,

//         roleAssignments: normalizedRoleAssignments,
//         roleKeys,
//         roleKey: roleKeys[0] || "",

//         currentUser: me, // optional debug
//       } as any);

//       // 5) route to correct queue based on roles
//       navigate(pickLandingRoute(roleKeys), { replace: true });
//     } catch (e: any) {
//       setErr(e?.message || "Login failed");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div className="login-container">
//       <img src={logo} alt="QAVACH Logo" className="login-logo" />

//       <h2>Login</h2>

//       <div className="login-buttons">
//         <input
//           style={{ padding: 12, borderRadius: 6, border: "1px solid #ddd" }}
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />

//         <input
//           style={{ padding: 12, borderRadius: 6, border: "1px solid #ddd" }}
//           placeholder="Password"
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />

//         {err && <div style={{ color: "crimson", fontSize: 14 }}>{err}</div>}

//         <Button onClick={handleLogin}>
//           {busy ? "Logging in..." : "Login"}
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default LoginScreen;






import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/LoginScreen.css";
import logo from "../assets/qavach-logo.png";
import Button from "../components/common/Button";
import { authApi } from "../services/authApi";
import { tokenStore } from "../services/tokenStore";
import { fetchCurrentUser } from "../services/currentUserApi";
import { useAuth } from "../context/AuthContext";

function pickLandingRoute(roleKeys: string[]) {
  const keys = roleKeys.map((x) => String(x).trim().toLowerCase());

  console.log("ROLE KEYS:", roleKeys);

  if (keys.includes("teledoctor")) return "/queue/teledoctor";
  if (keys.includes("tele_dentist") || keys.includes("teledental"))
    return "/queue/teledental";
  if (keys.includes("pediatric_resident") || keys.includes("pediatric"))
    return "/queue/pediatric";
  if (keys.includes("dermatologist") || keys.includes("dermatology"))
    return "/queue/dermatology";
  if (keys.includes("tele_final_doctor") || keys.includes("telefinaldoctor"))
    return "/queue/tele-final-doctor";

  throw new Error("No valid role found for routing");
}

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const handleLogin = async () => {
    setBusy(true);
    setErr(null);

    try {
      const resp = await authApi.login(email, password);
      const accessToken = resp.access_token;

      if (!accessToken)
        throw new Error("No access_token returned from backend");

      tokenStore.set({ accessToken });

      const me = await fetchCurrentUser(accessToken);

      const normalizedRoleAssignments = (me?.roleAssignments || []).map(
        (ra: any) => ({
          ...ra,
          role: {
            ...(ra.role || {}),
            key: String(ra?.role?.key || "").trim().toLowerCase(),
            name: String(ra?.role?.name || "").trim(),
          },
        }),
      );

      const roleKeys: string[] = normalizedRoleAssignments
        .filter((ra: any) => String(ra?.status).toLowerCase() === "active")
        .map((ra: any) => ra?.role?.key)
        .filter(Boolean);

      setAuth({ accessToken }, {
        name: me?.user?.raw?.name || "Doctor",
        email: me?.user?.raw?.email,
        picture: me?.user?.raw?.picture,
        roleAssignments: normalizedRoleAssignments,
        roleKeys,
        roleKey: roleKeys[0] || "",
        currentUser: me,
      } as any);

      navigate(pickLandingRoute(roleKeys), { replace: true });
    } catch (e: any) {
      setErr(e?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="medicare-login-wrapper">
      <div className="medicare-login-container">
        
        {/* Left Side: Branding & Visual Showcase */}
        <div className="login-brand-section">
          <div className="brand-header">
          </div>

          <div className="brand-hero-text">
            <h1>Compassionate Care, <br /><span className="highlight-text">Smarter Healthcare</span></h1>
            <p>Sign in to access your dashboard and manage your patients with ease.</p>
          </div>

          <div className="brand-graphic-container">
            <img 
              src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=700&q=80" 
              alt="Medical Stethoscope and Heart" 
              className="stethoscope-3d-graphic" 
            />
          </div>

          <div className="brand-footer-pill">
            <span>🛡️ Your Health. Our Priority.</span>
          </div>
        </div>

        {/* Right Side: Floating Login Card */}
        <div className="login-form-section">
          <div className="floating-auth-card">
            <div className="card-top-icon">
              <div className="avatar-logo-container">
                <img src={logo} alt="QAVACH Logo" className="card-logo-graphic" />
              </div>
            </div>

            <div className="auth-title-group">
              <h2>Welcome Back, <span>Doctor!</span></h2>
              <p>Please login to continue</p>
            </div>

            <div className="auth-form-fields">
              <div className="field-block">
                <label>Email Address</label>
                <div className="input-with-icon">
                  <span className="field-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                  </span>
                  <input
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="field-block">
                <label>Password</label>
                <div className="input-with-icon">
                  <span className="field-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                  </span>
                  <input
                    placeholder="Enter your password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span className="eye-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                  </span>
                </div>

              </div>

              {err && <div className="error-banner">{err}</div>}

              <div className="login-btn-wrapper">
                <Button onClick={handleLogin} disabled={busy}>
                  {busy ? "Logging in..." : "Login"}
                </Button>
              </div>

 
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default LoginScreen;